export function parseAnimateStyle  (lines, lineHeight) {
    const wait = 2.5;
    const duration = 2.0;
    let css = "";
        if (lines === 1) {
            css += `@keyframes messages-marquee-animate1 {\n`;
            css += `0% {transform: translateY(0)}\n`;
            css += `22.22222222222222% {transform: translateY(0px)}\n`;
            css += `50% {transform: translateY(0px)}\n`;
            css += `72.22222222222221% {transform: translateY(-22px)}\n`;
            css += `100% {transform: translateY(-22px)}\n`;
            css += `}\n`;
        } else {
            css += `@keyframes messages-marquee-animate${lines} {\n`;
            css += `0% {transform: translateY(0)}\n`;
            for (let i = 1; i <= lines; i++) {
                let stylePosition = `{transform: translateY(${(lineHeight * -i)}px)}`;
                css += `${((100 * (i - wait / (wait + duration))) / lines)}% ${stylePosition}\n`;
                css += `${(100 * i / lines)}% ${stylePosition}\n`;
            }
            css += `}\n\n`;
        }

    css += `[class*="marquee"] {
        line-height: 22px;
        animation-timing-function: ease;
        animation-delay: 2.5s;
        animation-iteration-count: infinite;
    }\n`;

        css += `.marquee${lines} {
            animation-duration: ${5 + 4 * (lines - 1)}s;
            animation-name: messages-marquee-animate${lines};
        }\n`;

    return css;
}

export default parseAnimateStyle;
